import {useSelector} from 'react-redux';
import urls from 'urls';
import {OverlayContentWrapper} from '~/CreateFabricInvitation/routes/EventGifting/components/OverlayContentWrapper/OverlayContentWrapper';
import {selectType} from '~/common/fabric/reducers/details/selectors';
import {getEventId} from '~/common/fabric/reducers/eviteEvent/selectors';
import {useScript} from '~/common/hooks/useScript';
import {ResponsivePanel} from '~library/organisms/ResponsivePanel';

interface CrowdfundOverlayProps {
  closeOverlay: () => void;
  isOpen: boolean;
}

export const CrowdfundOverlay = ({closeOverlay, isOpen}: CrowdfundOverlayProps) => {
  const eventId = useSelector(getEventId);
  const eventType = useSelector(selectType);

  const isScriptLoaded = useScript(urls.get('pledge_url', {pledgeDomain: window.pledge_url}), {
    id: 'pledgeSdkId',
  });

  if (!isScriptLoaded || !eventId) return null;

  return (
    <ResponsivePanel
      isOpen={isOpen}
      onClose={closeOverlay}
      showTitle={false}
      modalId="crowdfund"
      showCover
      renderMobileViewAs="bottom-sheet"
      hideHeaderDivider
    >
      <OverlayContentWrapper>
        <div
          className="plg-crowd"
          data-partner-key={window.pledge_key}
          data-event-type={eventType}
          data-item-id={`${eventId}_Crowdfund`}
          data-template="branding-2025"
        />
      </OverlayContentWrapper>
    </ResponsivePanel>
  );
};
